export default __webpack_public_path__ + "40c6aac557b6945b833995468400c053.pdf";